export default "__VITE_ASSET__BppGHxWK__"